// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--eMWRA";
export var socialIcon = "footer-module--socialIcon--2RPBI";